
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/confirm/[registerHashPath]",
      function () {
        return require("private-next-pages/register/confirm/[registerHashPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/confirm/[registerHashPath]"])
      });
    }
  